<template>
  <div v-if="itemsLoaded" class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="d-flex align-items-center">
            <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end"
            >
              <h5>Form Onay Bilgileri</h5>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive mb-0">
          <b-table
              class="datatables"
              :items="sessions"
              :fields="sessionsFields"
              responsive="sm"
          >
            <template v-slot:cell(name)="data">
              {{ data.item.name }}
            </template>

            <template v-slot:cell(education)="data">
              {{ formatEducation(data?.item?.education?.name) }}
            </template>    <template v-slot:cell(advisor)="data">
            {{ formatEducation(data?.item?.advisor?.name) }}
          </template>

            <template v-slot:cell(level)="data">
              <ul>
                <li v-for="level in data.item.level" :key="level.id">{{ level.name }}</li>
              </ul>
            </template>
            <template v-slot:cell(course)="data">
              <ul>
                <li v-for="course in data.item.course" :key="course.id">{{ course.name }}</li>
              </ul>
            </template>

            <template v-slot:cell(isActive)="data">
                  <span v-show="data.item.isActive"
                        class="badge badge-pill badge-soft-success font-size-13">Aktif</span>
              <span v-show="!data.item.isActive"
                    class="badge badge-pill badge-soft-danger font-size-13">Pasif</span>
            </template>
            <template v-slot:cell(agreements)="data">
                <ul>
                  <li>Ön Bilgilendirme Formu
                    <span v-show="data.item.details.preInfoAgreement" class="badge badge-pill badge-soft-success font-size-13">Onaylandı</span>
                    <span v-show="!data.item.details.preInfoAgreement" class="badge badge-pill badge-soft-danger font-size-13">Onaylanmadı</span>
                  </li>
                  <li>KVKK Aydınlatma Metni
                    <span v-show="data.item.details.kvkkAgreement" class="badge badge-pill badge-soft-success font-size-13">Onaylandı</span>
                    <span v-show="!data.item.details.kvkkAgreement" class="badge badge-pill badge-soft-danger font-size-13">Onaylanmadı</span>
                  </li>
                  <li>Mesafeli Satış Sözleşmesi
                    <span v-show="data.item.details.contractAgreement" class="badge badge-pill badge-soft-success font-size-13">Onaylandı</span>
                    <span v-show="!data.item.details.contractAgreement" class="badge badge-pill badge-soft-danger font-size-13">Onaylanmadı</span>
                  </li>
                </ul>
            </template>
            <template v-slot:cell(delete)="data">
              <button
                  :disabled="currentUser.role.includes('user')"
                  class="btn btn-danger d-flex py-2"
                  @click="openDelete(data.item)"
              >
                <i :class="`bx bx-trash bx-xs`"></i>
              </button>
            </template>
          </b-table>
        </div>
        <div class="row">
          <div class="col">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="page" :total-rows="totalRows" :per-page="perPage" @input="onPageChange"></b-pagination>

              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {customerMethods} from "@/state/helpers";
export default {
  name: "AgreementSessions",
  props: {
    user: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      sessions: [],
      itemsLoaded: false,
      sessionsFields: [
        {
          key: "date",
          label: "Tarih",
        },
        {
          key: "details.ip",
          label: "Ip",
        },
        {
          key: "details.mobile",
          label: "Mobil",
        },
        {
          key: "details.platform",
          label: "Masaüstü",
        },
        {
          key: "details.userAgent",
          label: "Tarayıcı",
        },
        {
          key: "details.contractNumber",
          label: "Evrak No",
        },
        {
          key: "agreements",
          label: "Formlar",
        },
      ],
      totalRows: 1,
      page: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100]
    }
  },
  methods: {
    ...customerMethods,
    onPageChange(newPage) {
      this.page = newPage;
      this.getCustomerSessions()
    },
    getCustomerSessions() {
      this.itemsLoaded = false;
      this.fetchCustomerAgreementSessions({
        id:this.user,
        page: this.page,
        limit: this.perPage
      }).then((res) => {
        this.totalRows = res.total;
        this.sessions = res.docs;
        this.itemsLoaded = true;
      });
    }
  },
  mounted() {
    this.getCustomerSessions()
  },
}
</script>

<style scoped>

</style>
